import type { BoxProps } from '@material-ui/core';
import { Box, Tooltip } from '@material-ui/core';
import clsx from 'clsx';
import React, { FunctionComponent, ReactNode } from 'react';
import badgeStyles from 'styles/badge';

export type BadgeColour =
  | 'green'
  | 'red'
  | 'darkRed'
  | 'blue'
  | 'grayBlue'
  | 'orange'
  | 'purple'
  | 'gray';

export type BadgeVariant = 'rounded' | 'square' | 'text';

type ExtendedBoxProps = BoxProps & {
  label?: string;
  icon?: 'dot' | ReactNode;
  color?: BadgeColour;
  variant?: BadgeVariant;
  tooltip?: string;
  capitalize?: boolean;
};

const TextField: FunctionComponent<ExtendedBoxProps> = ({
  label,
  icon,
  variant,
  color,
  tooltip,
  capitalize,
  ...props
}: ExtendedBoxProps) => {
  const classes = badgeStyles();

  const displayIcon = () => (icon && icon === 'dot' ? <span>●</span> : icon);

  const badgeComponent = (
    <Box
      {...props}
      className={clsx(
        classes.badge,
        classes[variant as BadgeVariant],
        classes[color as BadgeColour],
        capitalize && classes.capitalize,
        props.className
      )}
    >
      {displayIcon()}
      {label}
    </Box>
  );

  return tooltip ? (
    <Tooltip placement="top-start" title={tooltip}>
      {badgeComponent}
    </Tooltip>
  ) : (
    badgeComponent
  );
};

export default TextField;

TextField.defaultProps = {
  label: '',
  icon: undefined,
  color: 'gray' as BadgeColour,
  variant: 'square',
  tooltip: undefined,
  capitalize: false
};
